import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const SalesActionGridView = ({ timeSlots, calculatedActions, slotHeight, onSelectSchedule }) => {
    return (
        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                overflowY: 'auto',
                maxHeight: '600px',
                border: '1px solid #f1f3f5',
                borderRadius: '8px',
                position: 'relative',
                '&::-webkit-scrollbar': { width: '5px' },
                '&::-webkit-scrollbar-thumb': { backgroundColor: '#e0e0e0', borderRadius: '4px' }
            }}
        >
            <Box sx={{ position: 'relative', width: '100%' }}>
                {timeSlots.map((slot) => (
                    <Box 
                        key={slot}
                        sx={{ 
                            display: 'flex', 
                            flexDirection: 'row',
                            borderBottom: '1px solid #f1f3f5',
                            height: `${slotHeight}px`,
                            boxSizing: 'border-box'
                        }}
                    >
                        <Box 
                            sx={{ 
                                width: '60px', 
                                pt: 1.5, 
                                pr: 1.5,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'flex-start',
                                borderRight: '1px solid #f1f3f5',
                                backgroundColor: '#fafafa',
                                userSelect: 'none'
                            }}
                        >
                            <Typography 
                                variant="caption" 
                                sx={{ 
                                    fontWeight: slot.endsWith(':00') ? 700 : 400, 
                                    color: slot.endsWith(':00') ? '#495057' : '#adb5bd',
                                    fontSize: '0.75rem',
                                    fontFamily: 'monospace'
                                }}
                            >
                                {slot}
                            </Typography>
                        </Box>
                        <Box sx={{ flexGrow: 1, backgroundColor: 'transparent' }} />
                    </Box>
                ))}

                <Box 
                    sx={{ 
                        position: 'absolute', 
                        top: 0, 
                        left: '60px', 
                        right: 8,     
                        height: '100%', 
                        pointerEvents: 'none' 
                    }}
                >
                    {calculatedActions.map((action) => {
                        const totalCols = action.totalCols || 1;
                        const colIdx = action.colIdx || 0;
                        const widthPct = 100 / totalCols;
                        const leftPct = colIdx * widthPct;

                        // 🚀 slotHeight=40 기준 (40분=54px 이하, 1시간 이상=80px 이상)
                        const is40MinOrLess = action.height <= 54;
                        const isOver1Hour = action.height >= 80;

                        return (
                            <Paper
                                key={action.id}
                                elevation={3}
                                onClick={() => onSelectSchedule && onSelectSchedule(action)}
                                sx={{
                                    position: 'absolute',
                                    top: `${action.top + 3}px`, 
                                    height: `${action.height - 6}px`, 
                                    left: `calc(${leftPct}% + 4px)`,
                                    width: `calc(${widthPct}% - 8px)`,
                                    p: 1,
                                    backgroundColor: colIdx % 2 === 0 ? '#e8f5e9' : '#e3f2fd',
                                    borderLeft: colIdx % 2 === 0 ? '5px solid #2e7d32' : '5px solid #1565c0', 
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    pointerEvents: 'auto', 
                                    zIndex: 10 + colIdx,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    overflow: 'hidden',
                                    boxSizing: 'border-box',
                                    transition: 'all 0.2s ease',
                                    '&:hover': { backgroundColor: colIdx % 2 === 0 ? '#c8e6c9' : '#bbdefb', boxShadow: 6, zIndex: 100 }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 0.5, flexWrap: 'nowrap' }}>
                                    <Typography 
                                        variant="subtitle2" 
                                        sx={{ 
                                            fontWeight: 700, 
                                            fontSize: '0.85rem', 
                                            color: colIdx % 2 === 0 ? '#1b5e20' : '#0d47a1', 
                                            lineHeight: 1.2, 
                                            overflow: 'hidden', 
                                            textOverflow: 'ellipsis', 
                                            whiteSpace: 'nowrap',
                                            flexShrink: 1
                                        }}
                                    >
                                        {action.title}
                                    </Typography>
                                    
                                    {is40MinOrLess && (
                                        <Typography 
                                            variant="caption" 
                                            sx={{ 
                                                color: colIdx % 2 === 0 ? '#388e3c' : '#1976d2', 
                                                fontSize: '0.68rem', 
                                                fontWeight: 500,
                                                whiteSpace: 'nowrap',
                                                flexShrink: 0
                                            }}
                                        >
                                            (클릭하여 확인)
                                        </Typography>
                                    )}
                                </Box>
                                
                                {action.extendedProps?.companyNm && (
                                    <Typography variant="caption" sx={{ color: '#455a64', display: 'block', fontSize: '0.75rem', mt: 0.5, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        🏢 {action.extendedProps.companyNm}
                                    </Typography>
                                )}
                                
                                {isOver1Hour && action.extendedProps?.content && (
                                    <Typography variant="caption" sx={{ color: '#546e7a', display: 'block', fontSize: '0.7rem', mt: 0.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        📝 {action.extendedProps.content}
                                    </Typography>
                                )}
                            </Paper>
                        );
                    })}
                </Box>
            </Box>
        </Box>
    );
};

export default SalesActionGridView;
